/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";

import routes from "routes.js";
//import Logo from "../../assets/img/logo.png";
import MainLogo from "../../assets/img/MainLogo.png";
//import personal from "../../assets/img/personal.png";

import { FiLogOut } from "react-icons/fi";
import { FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Toast from "components/toaster";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Avatar from "react-avatar";
import { IoMdClose } from "react-icons/io";
import { useFormik } from "formik";
import InputField from "components/fields/InputField";
import EventService from "services/events.service";
import AuthService from "services/auth.service";
import imageCompression from "browser-image-compression";
import { FaCamera } from "react-icons/fa";
import { AiOutlineEdit } from "react-icons/ai";
import Loader from "../../assets/img/loader.gif";

const Sidebar = ({ open, onClose, onLinkClick }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const carStorageString = localStorage.getItem("car-meet-storage");
  const carMeetStorage = JSON.parse(carStorageString);

  useEffect(() => {
    if (carMeetStorage) {
      formik.setFieldValue("_id", carMeetStorage?._id);
      formik.setFieldValue("email", carMeetStorage?.email);
      formik.setFieldValue("name", carMeetStorage?.name);
      formik.setFieldValue("username", carMeetStorage?.username);
      formik.setFieldValue("firstname", carMeetStorage?.firstname);
      formik.setFieldValue("lastname", carMeetStorage?.lastname);
      formik.setFieldValue("profilepic", carMeetStorage?.profilepic);
      setSelectedImage(carMeetStorage?.profilepic);
    }
  }, []);

  const localdata = JSON.parse(localStorage.getItem("car-meet-storage"));

  const handleOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleClose = () => {
    setIsOpen(false);
    document.body.style.overflow = "unset";
  };

  const formik = useFormik({
    initialValues: {
      _id: "",
      username: "",
      name: "",
      firstname: "",
      lastname: "",
      email: "",
      profilepic: "",
    },
    onSubmit: async (values) => {
      setIsLoading("submit");
      try {
        const response = await AuthService.updateProfile(values);
        carMeetStorage.firstname = values.firstname;
        carMeetStorage.lastname = values.lastname;
        carMeetStorage.name = values.name;
        carMeetStorage.profilepic = values.profilepic;
        carMeetStorage.username = values.username;
        carMeetStorage._id = values._id;

        localStorage.setItem(
          "car-meet-storage",
          JSON.stringify(carMeetStorage)
        );
        Toast("success", "Profile updated successfully!");
        handleClose();
      } catch (error) {
        Toast("error", error.response.data.message);
      } finally {
        setIsLoading("");
      }
    },
  });

  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    setIsLoading("image");

    try {
      const options = {
        maxSizeMB: 0.8,
        maxWidthOrHeight: 1000,
        useWebWorker: true,
        initialQuality: 0.8,
      };

      const compressedFile = await imageCompression(file, options);

      const formData = new FormData();
      formData.append("files", compressedFile);

      const response = await EventService.fileUpload(formData);
      setSelectedImage(response?.data?.files?.[0]);
      formik.setFieldValue("profilepic", response?.data?.files?.[0]);
    } catch (error) {
      Toast("error", error.response.data.message);
    } finally {
      setIsLoading("");
    }

    e.target.value = "";
  };

  const handleLogoutClick = () => {
    setIsLogoutModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleLogoutCancel = () => {
    setIsLogoutModalOpen(false);
    document.body.style.overflow = "unset";
  };

  const handleLogout = () => {
    setIsLogoutModalOpen(false);
    document.body.style.overflow = "unset";
    localStorage.clear();
    Toast("success", "Logout successfully");
    setTimeout(() => {
      navigate("/login");
    }, 1000);
  };

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex h-full flex-col bg-navy-800 pb-10 text-white shadow-2xl shadow-white/5 transition-all md:!z-50 lg:!z-50 xl:!z-0 overflow-y-auto ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[25px] my-6 flex items-center`}>
        <div className="ml-1 mt-1 flex gap-2 font-poppins font-bold uppercase text-white">
          <img src={MainLogo} alt="Logo" className="h-[40px] w-[40px] rounded-md" />{" "}
          <p className="text-[26px]">Hangout</p>
        </div>
      </div>
      <div className="mb-7 h-px bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={routes} onLinkClick={onLinkClick} />
      </ul>

      {/* Separator */}
      {/* <div className="my-0.5 h-px mt-4 bg-white/30 mx-8" /> */}

      {/* Profile Card Button */}
      <ul
        className="group flex cursor-pointer  items-center gap-3 px-8 py-2 mx-1 hover:bg-white/5 rounded-lg transition-colors mb-6"
        onClick={handleOpen}
      >
        {localdata?.profilepic ? (
          <img
            src={
              localdata.profilepic.includes("api.car-hangout.com") ||
              localdata.profilepic.includes("hangoutdev.s3.amazonaws.com")
                ? localdata.profilepic
                : `https://api.car-hangout.com${localdata.profilepic}`
            }
            alt="Profile"
            className="h-10 w-10 rounded-full object-cover"
          />
        ) : (
          <Avatar
            name={localdata?.name || localdata?.email || "User"}
            size="44"
            round={true}
            className="flex-shrink-0"
          />
        )}
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-base font-semibold text-white group-hover:text-white">
            {localdata?.name || `${localdata?.firstname || ""} ${localdata?.lastname || ""}`.trim() || "User"}
          </span>
          <span className="text-xs text-[#8E8E8E] group-hover:text-gray-300">
            {localdata?.email || ""}
          </span>
        </div>
        <AiOutlineEdit className="text-lg text-white/60 group-hover:text-white transition-colors mr-4" />
      </ul>

      {/* Separator */}
      {/* <div className="my-5 h-px bg-white/20 mx-8" /> */}

      <ul
        className="group flex cursor-pointer items-center gap-3 pl-6 pr-8 py-2 mx-8 rounded-xl"
        style={{ backgroundColor: '#FF3F211A' }}
        onClick={handleLogoutClick}
      >
        <FiLogOut className="text-lg text-[#FF3F21] " />
        <span className="text-[#FF3F21]  font-medium ">Logout</span>
      </ul>

      {/* Free Horizon Card */}
      {/* <div className="flex justify-center">
        <SidebarCard />
      </div> */}

      {/* Nav item end */}

      {/* Profile Modal */}
      {isOpen &&
        createPortal(
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
            <div className="max-h-[90vh] w-[80%] sm:w-[460px] overflow-auto rounded-xl bg-navy-800 p-6 text-white shadow-lg">
            <div className="relative flex justify-center py-4">
              <p className="text-2xl font-semibold">Profile</p>
              <IoMdClose
                className="absolute right-0 cursor-pointer text-2xl"
                onClick={handleClose}
              />
            </div>

            <form onSubmit={formik.handleSubmit}>
              <div className="h-full">
                <input
                  type="file"
                  hidden
                  id="upload"
                  accept="image/*"
                  onChange={handleFileChange}
                />
                {isLoading === "image" ? (
                  <div className="mt-2 flex min-h-11 w-full items-center justify-center">
                    <img
                      src={Loader}
                      alt="Loading..."
                      className="mx-auto h-10 w-10"
                    />
                  </div>
                ) : (
                  <div className="mb-2 mt-1">
                    {selectedImage ? (
                      <div className="flex h-full w-full justify-center">
                        <label
                          htmlFor="upload"
                          className="relative mb-3 mt-1 flex h-full max-h-32 w-full max-w-32 cursor-pointer justify-center"
                        >
                          <img
                            src={
                              selectedImage.includes("api.car-hangout.com") ||
                              selectedImage.includes(
                                "hangoutdev.s3.amazonaws.com"
                              )
                                ? selectedImage
                                : `https://api.car-hangout.com${selectedImage}`
                            }
                            className="h-full max-h-32 w-full max-w-32 cursor-pointer rounded-full object-cover"
                          />
                          <div className="w-8 h-8 absolute -bottom-1 right-2 rounded-full border-navy-800 border border-spacing-3 bg-white p-1 flex items-center justify-center">
                            <FaCamera
                              className="text-primary w-4 h-4"
                            />
                          </div>
                        </label>
                      </div>
                    ) : (
                      <label
                        htmlFor="upload"
                        className="mt-1 flex h-full min-h-11 w-full cursor-pointer items-center justify-center border border-dashed border-white/10 duration-300 hover:bg-white/10"
                      >
                        Choose Profile Pic
                      </label>
                    )}
                  </div>
                )}

                {formik.touched.images && formik.errors.images && (
                  <p className="validation-error">{formik.errors.images}</p>
                )}
              </div>

              <div>
                <InputField
                  variant="form"
                  extra="mb-2"  
                  label="Email"
                  placeholder="Enter your email"
                  id="email"
                  type="text"
                  name="email"
                  value={formik.values.email}
                  disabled
                />
                {formik.touched.email && formik.errors.email && (
                  <p className="validation-error">{formik.errors.email}</p>
                )}
              </div>
              <div>
                <InputField
                  variant="form"
                  extra="mb-2"
                  label="Name"
                  placeholder="Enter your name"
                  id="name"
                  type="text"
                  name="name"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name && (
                  <p className="validation-error">{formik.errors.name}</p>
                )}
              </div>
              <div>
                <InputField
                  variant="form"
                  extra="mb-2"
                  label="Username"
                  placeholder="Enter your username"
                  id="username"
                  type="text"
                  name="username"
                  onChange={formik.handleChange}
                  value={formik.values.username}
                />
                {formik.touched.username && formik.errors.username && (
                  <p className="validation-error">{formik.errors.username}</p>
                )}
              </div>
              <div>
                <InputField
                  variant="form"
                  extra="mb-2"
                  label="First Name"
                  placeholder="Enter your firstname"
                  id="firstname"
                  type="text"
                  name="firstname"
                  onChange={formik.handleChange}
                  value={formik.values.firstname}
                />
                {formik.touched.firstname && formik.errors.firstname && (
                  <p className="validation-error">{formik.errors.firstname}</p>
                )}
              </div>
              <div>
                <InputField
                  variant="form"
                  extra="mb-2"
                  label="Last Name"
                  placeholder="Enter your lastname"
                  id="lastname"
                  type="text"
                  name="lastname"
                  onChange={formik.handleChange}
                  value={formik.values.lastname}
                />
                {formik.touched.lastname && formik.errors.lastname && (
                  <p className="validation-error">{formik.errors.lastname}</p>
                )}
              </div>

              <button
                type="submit"
                className={`linear mt-5 flex w-full items-center justify-center rounded-xl bg-orangePrimary py-[8px] text-base font-medium text-white transition duration-200 ${
                  isLoading === "submit" ? "" : "hover:bg-orangePrimary/80"
                }  active:bg-orangePrimary/80`}
                disabled={isLoading === "submit"}
              >
                {isLoading === "submit" ? (
                  <img src={Loader} alt="Loader" className="h-6 w-6" />
                ) : (
                  "Update"
                )}
              </button>
            </form>
          </div>
        </div>,
          document.body
        )}

      {/* Logout Confirmation Modal - Rendered at root level using Portal */}
      {isLogoutModalOpen &&
        createPortal(
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
            <div className="w-[85%] sm:w-96 rounded-xl bg-navy-800 p-6 shadow-lg">
              <h2 className="mb-4 text-xl font-bold text-white">Logout</h2>
              <p className="mb-6 text-gray-600">
                Are you sure you want to logout?
              </p>
              <div className="flex justify-end space-x-4">
                <button
                  onClick={handleLogoutCancel}
                  className="px-5 py-2.5 rounded-lg bg-white/10 text-white hover:bg-white/20 transition-all duration-200 font-semibold text-sm border border-white/20"
                >
                  Cancel
                </button>
                <button
                  onClick={handleLogout}
                  className="w-24 rounded-md bg-orangePrimary px-4 py-2 text-white hover:opacity-90"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default Sidebar;
